import { render, staticRenderFns } from "./PcqActionList.vue?vue&type=template&id=192251fb&"
import script from "./PcqActionList.vue?vue&type=script&lang=js&"
export * from "./PcqActionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports